import ProfileIcon from "../Icons/profile-icon";
import LogoutIcon from "../Icons/logout-icon";
import { LEFT_SIDE_BAR_SELECTED } from "./leftNavbar";
import { PROFILE_COMPONENT } from "../Profile/profilePageWrapper";
import { logout } from "../../Actions/loginAction";
import { useDispatch, useSelector } from "react-redux";
import { forwardRef } from "react";
import styles from "./layout.module.css";
import Avatar from "../CommonComponents/avatar/Avatar";
import { enterpriseDetailsSelector } from "../../Reducers/enterpriseDetailsReducer";
import { getOrgNameBasedOnLevel } from "../../Util/dataHelper";
import { enterpriseLevelsDetailsSelector } from "../../Reducers/enterpriseLevelsDetailsReducer";

const Separator = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 280 2"
      fill="none"
      className={styles.profilePopupSeparator}
    >
      <path d="M0 1H280" stroke="#E3E4EB" />
    </svg>
  );
};

const PopupLink = ({ icon, text, onClick }) => {
  return (
    <div className={styles.profilePopupLink} onClick={onClick}>
      <div className={styles.profilePopupLinkIcon}>{icon}</div>
      <div className={styles.profilePopupLinkText}>{text}</div>
    </div>
  );
};



const ProfilePopup = forwardRef((props, ref) => {
  const partnerDetails = useSelector(enterpriseDetailsSelector);
  const enterpriseLevelsDetails = useSelector(enterpriseLevelsDetailsSelector);
  const dispatch = useDispatch();

  const links = [
    {
      icon: <ProfileIcon />,
      text: "Profile",
      component: PROFILE_COMPONENT,
    },
    // {
    //   icon: <UsersRolesIcon />,
    //   text: "Users & roles",
    //   component: USERS_AND_ROLES_COMPONENT,
    //   show: (
    //     partnerDetails.getAccessLevel() === ADMIN &&
    //     partnerDetails.getAdminLevel() === ENTERPRISE
    //   )
    // }
  ]

  return (
    <div ref={ref} className={styles.profilePopup}>

      <div className={styles.profilePopupInfo}>
        <div>
          <Avatar name={partnerDetails.name} size={"36px"} variant="green" />
          <div className={styles.profilePopupInfoTexts}>
            <div className={styles.profilePopupInfoAdminName}>{partnerDetails.name}</div>
            <div className={styles.profilePopupInfoEnterpriseName}>{getOrgNameBasedOnLevel(partnerDetails, enterpriseLevelsDetails)}</div>
          </div>
        </div>
      </div>

      <Separator />

      <div className={styles.profilePopupLinks}>
        {links.filter(link => link.show === undefined || link.show).map((link, index) => (
          <PopupLink key={index} icon={link.icon} text={link.text} onClick={() => dispatch({
            type: LEFT_SIDE_BAR_SELECTED,
            payload: link.component,
          })} />
        ))}
      </div>

      <Separator />

      <div className={styles.profilePopupLinks}>
        <PopupLink icon={<LogoutIcon />} text="Log Out" onClick={() => dispatch(logout())} />
      </div>
    </div>
  );
});

export default ProfilePopup;
